// Modules
import styled from "styled-components"

// Constants
import colors from "~constants/colors"

// Icons
import NoPictureIcon from "~images/icons/no-picture.svg?react"

const CoverWrapper = styled.div`
  align-items: center;
  background-color: ${colors.gray2};
  display: flex;
  justify-content: center;
  height: 100%;

  svg {
    height: 100px;
    opacity: 0.35;
  }
`

const NoCoverImage = () => {
  return (
    <CoverWrapper>
      <NoPictureIcon />
    </CoverWrapper>
  )
}

export default NoCoverImage
